function slugify(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)+/g, "");
}

export function normalizeQuestions(rawQuestions = []) {
  return rawQuestions.map((question, index) => {
    const label =
      question.label ??
      question.question ??
      question.text ??
      `Question ${index + 1}`;
    const id = (question.id ?? slugify(label)) || `q${index + 1}`;

    let type = question.type;
    if (type === "select" || type === "radio") type = "single";
    if (type === "checkbox") type = "multi";

    if (!type) {
      if (Array.isArray(question.options) && question.options.length > 0) {
        type = question.multiple ? "multi" : "single";
      } else {
        type = "text";
      }
    }

    return {
      id: String(id),
      label: String(label),
      type,
      options: (question.options ?? []).map(String),
      required: !!question.required,
    };
  });
}

export function buildLabelMaps(templates = []) {
  const bySlug = {};
  const nameToSlug = {};

  for (const template of templates) {
    if (
      !template ||
      !template.name ||
      !template.slug ||
      !Array.isArray(template.questions)
    ) {
      continue;
    }

    nameToSlug[String(template.name).trim().toLowerCase()] = template.slug;
    bySlug[template.slug] = {};

    for (const question of template.questions) {
      if (!question || !question.id) continue;
      bySlug[template.slug][question.id] =
        question.label ||
        question.title ||
        question.text ||
        question.question ||
        String(question.id);
    }
  }

  return { bySlug, nameToSlug };
}

export function getLabelForItem(response, item, maps) {
  const backendLabel = (item?.question ?? "").trim();
  const id = String(item?.id ?? "").trim();

  const looksLikePlaceholder =
    !backendLabel ||
    backendLabel.toLowerCase() === id.toLowerCase() ||
    /^q\d+$/i.test(backendLabel);

  if (!looksLikePlaceholder) return backendLabel;

  const { bySlug, nameToSlug } = maps;
  const slug =
    (response.template_slug && String(response.template_slug).trim()) ||
    (response.template_name &&
      nameToSlug[String(response.template_name).trim().toLowerCase()]) ||
    null;

  if (slug && bySlug[slug] && bySlug[slug][id]) {
    return bySlug[slug][id];
  }

  return id || "Untitled question";
}

export function normalizeAnswer(answer) {
  if (answer === null || answer === undefined) return "—";
  if (Array.isArray(answer)) return answer.join(", ");

  if (typeof answer === "object") {
    const truthyValues = Object.entries(answer)
      .filter(([, value]) => !!value)
      .map(([key]) => key);

    if (truthyValues.length) return truthyValues.join(", ");

    try {
      return JSON.stringify(answer);
    } catch {
      return String(answer);
    }
  }

  return String(answer);
}

export function downloadTextFile(text, filename) {
  const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
